/* eslint-disable import/no-anonymous-default-export */
import React from "react";
export default ({ location: { pathname } }) => <h1>{pathname} </h1>;
